// Adds https:// to links typed without it (e.g. "orcid.org/0000-..." -> "https://orcid.org/0000-...")
export const normalizeUrl = (value) => {
  const url = (value || '').trim();
  if (!url) return '';
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};
